module.exports = __webpack_public_path__ + "img/32.06e98bb6.jpg";